import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function IlkyardimEgitimiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'İlkyardım Eğitimi | Adana OSGB Mersin Hatay Osmaniye | ASSA Akademi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana ilkyardım eğitimi, Mersin ilkyardım eğitimi, Hatay ilkyardım eğitimi, Osmaniye ilkyardım eğitimi. ASSA Akademi sertifikalı CPR, temel yaşam desteği, ilk yardım müdahale eğitimi.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana ilkyardım eğitimi, Mersin ilkyardım eğitimi, Hatay ilkyardım eğitimi, Osmaniye ilkyardım eğitimi, CPR eğitimi, temel yaşam desteği');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/egitimler/ilkyardim-egitimi');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "İlkyardım Eğitimi",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde ASSA Akademi sertifikalı ilkyardım ve temel yaşam desteği eğitimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA Akademi",
        "telephone": "+90-850-346-2772"
      },
      "areaServed": ["Adana", "Mersin", "Hatay", "Osmaniye"],
      "url": "https://www.assaosgb.com.tr/egitimler/ilkyardim-egitimi"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-600 to-green-800 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">İlkyardım Eğitimi</h1>
            <p className="text-xl md:text-2xl mb-8 text-green-100">
              ASSA Akademi ile Temel İlkyardım ve Yaşam Desteği Eğitimi
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <span className="bg-white/20 px-4 py-2 rounded-full">Adana İlkyardım</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Mersin İlkyardım</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Hatay İlkyardım</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Osmaniye İlkyardım</span>
            </div>
          </div>
        </div>
      </section>

      {/* ASSA Akademi Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">ASSA Akademi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Adana, Mersin, Hatay ve Osmaniye illerinde ilkyardım konusunda 
              uzmanlaşmış ASSA Akademi, hayat kurtaran bilgileri uygulamalı eğitimlerle öğretir.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/0bdd7c76f5c3da41f349883cb437f427.jpg"
                alt="ASSA Akademi İlkyardım Eğitimi"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">CPR Eğitimi</h3>
                  <p className="text-gray-600">Kalp masajı ve yapay solunum teknikleri</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                  <i className="ri-first-aid-kit-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Uygulamalı Eğitim</h3>
                  <p className="text-gray-600">Gerçek senaryolarla uygulamalı ilkyardım müdahalesi</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Sertifikalı Program</h3>
                  <p className="text-gray-600">Uluslararası standartlarda sertifikalı ilkyardım eğitimi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eğitim İçeriği */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">İlkyardım Eğitimi İçeriği</h2>
            <p className="text-lg text-gray-600">Kapsamlı ilkyardım eğitimi programımız</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-heart-pulse-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temel Yaşam Desteği</h3>
              <p className="text-gray-600">CPR, kalp masajı ve yapay solunum teknikleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-scissors-cut-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Kanama Kontrolü</h3>
              <p className="text-gray-600">Farklı kanama türleri ve durdurma yöntemleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-bone-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Kırık ve Çıkıklar</h3>
              <p className="text-gray-600">Kemik kırıkları ve eklem çıkıklarına müdahale</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-fire-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yanık Müdahalesi</h3>
              <p className="text-gray-600">Farklı derece yanıklara ilkyardım müdahalesi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-lungs-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Boğulma Müdahalesi</h3>
              <p className="text-gray-600">Heimlich manevrası ve hava yolu açma teknikleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-thermometer-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Şok ve Bayılma</h3>
              <p className="text-gray-600">Şok durumu ve bayılma vakalarına müdahale</p>
            </div>
          </div>
        </div>
      </section>

      {/* Şehirler */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmet Verdiğimiz İller</h2>
            <p className="text-lg text-gray-600">ASSA Akademi İlkyardım Eğitimleri</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-first-aid-kit-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Adana</h3>
              <p className="text-gray-600">Adana İlkyardım Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-first-aid-kit-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mersin</h3>
              <p className="text-gray-600">Mersin İlkyardım Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-first-aid-kit-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hatay</h3>
              <p className="text-gray-600">Hatay İlkyardım Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-first-aid-kit-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Osmaniye</h3>
              <p className="text-gray-600">Osmaniye İlkyardım Eğitimi</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">İlkyardım Eğitimi Almak İster misiniz?</h2>
          <p className="text-xl text-green-100 mb-8">
            ASSA Akademi ile hayat kurtaran bilgileri öğrenin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Bilgi Al
            </Link>
            <a 
              href="tel:08503462772" 
              className="bg-green-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors whitespace-nowrap"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
